import { HttpClient, HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root'
})
export class BrokerInvitationService {

  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  public confirmInvitation(token: string): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/broker-invitation/confirm', 
      { token },
    );
  }
}
